import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deleteMetricModalHeader: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.delete-metric-modal-header',
		defaultMessage: 'Delete Metric',
		description: 'Modal header text when deleting a metric',
	},
	deleteMetricModalBody: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.delete-metric-modal-body',
		defaultMessage:
			'Deleting this metric will remove the associated SLA from all issues in this project.',
		description: 'Modal body text when deleting a report',
	},
	deleteButton: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.delete-button',
		defaultMessage: 'Confirm',
		description: 'Delete button text',
	},
	cancelButton: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Cancel button text',
	},
});
